module.exports = __webpack_public_path__ + "static/media/cq_allegato b.93f419fd.svg";